module.exports = ".btn-primary-outline {\n    background-color: transparent;\n    border-color: #ccc;\n    color: #fff!important;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/Service/service.component.css
// module id = ./src/app/component/Service/service.component.css
// module chunks = main